import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#eeeeee] text-gray-600 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-6 md:gap-10 mb-8">
          {/* 회사 정보 */}
          <div>
            <div className="mb-4">
              {/* 로고 */}
              <img
                src="/logo-full.png"
                alt="동두천시 글로벌인재교육센터"
                className="h-12 w-auto"
              />
            </div>
            <div className="space-y-2 text-sm">
              <p>(주)한원글로벌 동두천지점</p>
              <p>대표자: 김한경</p>
              <p className="leading-relaxed">
                주소: 경기도 동두천시 동두천로 97, 2층<br />
                (지행동, 동두천싸이언스타워)
              </p>
            </div>
          </div>

          {/* 빠른 링크 */}
          <div>
            <h3 className="text-gray-800 font-bold text-lg mb-4">빠른 링크</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about/greeting" className="hover:text-green-600 transition-colors">
                  센터소개
                </Link>
              </li>
              <li>
                <Link to="/curriculum" className="hover:text-green-600 transition-colors">
                  교육과정
                </Link>
              </li>
              <li>
                <Link to="/notice" className="hover:text-green-600 transition-colors">
                  공지사항
                </Link>
              </li>
              <li>
                <Link to="/about/location" className="hover:text-green-600 transition-colors">
                  오시는 길
                </Link>
              </li>
            </ul>
          </div>

          {/* 고객지원 */}
          <div>
            <h3 className="text-gray-800 font-bold text-lg mb-4">고객지원</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/community/faq" className="hover:text-green-600 transition-colors">
                  자주묻는 질문
                </Link>
              </li>
              <li>
                <Link to="/application/register" className="hover:text-green-600 transition-colors">
                  수강신청
                </Link>
              </li>
              <li>
                <Link to="/mypage" className="hover:text-green-600 transition-colors">
                  마이페이지
                </Link>
              </li>
            </ul>
          </div>

          {/* 소셜 링크 */}
          <div className="flex items-start justify-start md:justify-end">
            <div className="flex items-center gap-3">
              <a
                href="https://www.youtube.com/@ddcglobalcenter"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity"
              >
                <img src="/youtube.png" alt="YouTube" className="h-10 sm:h-12 md:h-16 object-contain" />
              </a>
              <a
                href="https://www.instagram.com/help.dgtc/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity"
              >
                <img src="/instagram.png" alt="Instagram" className="h-14 sm:h-18 md:h-24 object-contain" />
              </a>
              <a
                href="http://pf.kakao.com/_xdWzpn"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity"
              >
                <img src="/kakaotalk-new.png" alt="KakaoTalk" className="h-9 sm:h-11 md:h-14 object-contain" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-300 pt-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Dongducheon Global Talent Center. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
